<div class="container-fluid">
    <div class="row">
        <div class="col-12 bg-img d-flex justify-content-center">
            <div class="content-wrapper">
                <div class="row">
                    <div class="col-12 d-flex justify-content-center">
                        <div class="content">
                            <h1 class="text-center">Two Brothers With A <span class="text-blue">Dream...</span></h1>
                            <p class="text-center pt-3">Eazy Breezy is owned and operated by two brothers with a dream. Jordan Zaik is our HVAC Specialist, Clinton Zaik is our Plumbing Specialist and together they make Eazy Breezy. These brothers have always had a dream to own and operate their own local business. Now that this dream has become a reality, they take their customer's satisfaction personally. As service technicians, they take extra care to make sure every single one of their customers is taken care of.</p>
                            <div class="row pt-3 content-pics">
                                <div class="col-lg-6 text-center pt-3"><!--STRANGE: text-center works for centering image. But d-flex justify-content-center does not.-->
                                    <img src="../../../assets/site-theme/jordan.png" alt="Jordan Zaik">
                                    <div class="text-center pt-2">
                                        <h3><span class="text-red">Jordan</span> Zaik</h3>
                                        <h4>HVAC Specialist</h4>
                                    </div>
                                </div>
                                <div class="col-lg-6 text-center pt-3">
                                    <img src="../../../assets/site-theme/clinton.png" alt="Clinton Zaik">
                                    <div class="text-center pt-2">
                                        <h3><span class="text-red">Clinton</span> Zaik</h3>
                                        <h4>Plumbing Specialist</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>